var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module"
  }, [typeof _vm.chemicalContainer !== 'undefined' ? _c('fieldset', [_c('legend', [_vm._v("Container Data")]), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Chemical Name: ")]), _vm._v("\n        " + _vm._s(_vm.getChemicalName) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Product Name: ")]), _vm._v("\n        " + _vm._s(_vm.getProductName) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Product Number: ")]), _vm._v("\n        " + _vm._s(_vm.getProductNumber) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Manufacturer: ")]), _vm._v("\n        " + _vm._s(_vm.getManufacturerName) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Container ID: ")]), _vm._v("\n        " + _vm._s(_vm.getContainerId) + "\n      ")])], 1)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }